export const CATEGORY_TYPE_OF_LIST = {
    Audio: '1',
    Video: '2',
    VOD: '4',
    AOD: '5',
}
